/** 
 * this is the fly transition from svelte with added scale param 
 * https://github.com/sveltejs/svelte/blob/master/src/runtime/transition/index.ts
 * 
 */

import { cubicOut } from 'svelte/easing';

export function zoom(node, {
	delay = 0,
	duration = 400,
	easing = cubicOut,
	x = 0,
  y = 0,
  scale = 1.5, // this is new
	opacity = 0
}) {
	const style = getComputedStyle(node);
	const target_opacity = +style.opacity;
	const target_scale = 1;  // this is new
	const transform = style.transform === 'none' ? '' : style.transform;

	const od = target_opacity * (1 - opacity);

	const oe = target_scale * (1 - scale);

	return {
		delay,
		duration,
		easing,
		css: (t, u) => `
			transform: ${transform} translate(${(1 - t) * x}px, ${(1 - t) * y}px) scale(${target_scale - (oe * u)});
			opacity: ${target_opacity - (od * u)}`                               /* --- scale is new --- */
	};
}